<div [formGroup]="form" style="min-height: 400px;">
    <div class="inputs input-grid-gaps">
        <app-select-input
            [form]="form"
            id="subType"
            [staticOptions]="contactTypeEnumOptions"
            label="enum.contactType.label"
            valueKey="value"
            class="fr-4"
            [showClear]="false"
            [autoDisplayFirst]="true"
        ></app-select-input>

        @if (create) {
            <app-inner-modal
                #selectExistingModal
                [header]="'folderContact.selectExisting' | translate"
                [ngClass]="{'fr-4': isDoctor || isUserSelected, 'fr-8': !isDoctor && !isUserSelected}"
            >
                <div class="flex flex-column gap">
                    <app-select-user
                        [form]="form"
                        (userSelected)="updateFormWithSelectedUser($event)"
                        class="pt-2"
                        id="existingUserId"
                        [doctorOnly]="isDoctor"></app-select-user>
                    <app-select-input
                        [form]="form"
                        [infiniteScroll]="store2.customContacts"
                        id="customContactId"
                        label="folderContact.fields.addressBookContact"
                        valueKey="id"
                        labelKey="name"
                        filterBy="name,surname,email"
                        [autoDisplayFirst]="false"
                        [showClear]="true"
                    >
                        <ng-template #item let-item>
                            <div class="flex flex-column gap-xx-small">
                                <span>{{ item.titleBeforeName }} {{ item.name || item.company }} {{ item.surname }} {{ item.titleAfterName }}</span>
                                @if (item.email) {
                                    <small class="font-size-x-small text-secondary">{{ item.email }}</small>
                                }
                            </div>
                        </ng-template>
                    </app-select-input>
                    @if (form.value.customContactId) {
                        <app-info-float-message
                            message="folderContact.messages.addressBookContactConversion"
                        ></app-info-float-message>
                    }
                    <app-action-buttons
                        primaryButtonLabel="common.select"
                        (primaryClickEvent)="select($event)"
                        [primaryButtonDisability]="!form.value.existingUserId && !form.value.customContactId"
                        [secondaryButtonVisibility]="false"
                    ></app-action-buttons>
                </div>
            </app-inner-modal>
        } @else {
            <div class="fr-4">&nbsp;</div>
        }

        @if (isUserSelected) {
            <div class="flex gap-small align-items-center fr-4">
                <span class="font-bold align-self-center">
                    @if (selectedUser) {
                        {{ selectedUser | formatPerson }}
                    } @else {
                        {{ selectedAddressBookContactName }}
                    }
                </span>
                <app-button icon="pi-times" severity="danger" [rounded]="true" [text]="true"
                    (clickEvent)="deselect()"></app-button>
            </div>
        }

        @if (isDoctor && enableUserEdit) {
            <app-text-input id="icpOfDoctor" class="fr-4" [form]="form"></app-text-input>
        }

        @if (!create) {
            <div class="fr-12"></div>
        }

        @if (enableUserEdit && !selectedUser) {
            <app-text-input id="titleBeforeName" class="fr-2" [form]="form"></app-text-input>
            <app-text-input id="name" class="fr-4" [form]="form"></app-text-input>
            <app-text-input id="surname" class="fr-4" [form]="form"></app-text-input>
            <app-text-input id="titleAfterName" class="fr-2" [form]="form"></app-text-input>
            <app-phone-input id="mobile" icon="pi-mobile" class="fr-4 mr-2"
                [form]="form"
            ></app-phone-input>
            <app-phone-input id="phone" class="fr-4" [form]="form"></app-phone-input>
            <app-email-input id="email" class="fr-4" [form]="form"></app-email-input>
            <app-address-input id="address" class="fr-4" [form]="form"></app-address-input>
            <div class="fr-8"></div>
        }

        @if (isContact) {
            <app-text-input id="clientRelation" class="fr-4" [form]="form"></app-text-input>
            <app-text-input id="contactCircumstance" class="fr-5" [form]="form"></app-text-input>
            <app-text-input id="info" class="fr-3" [form]="form"></app-text-input>
        }

        @if (isAuthorized) {
            <app-text-input id="purposeOfAuthorization" class="fr-6" [form]="form"></app-text-input>
            <app-text-input id="scopeOfAuthorization" class="fr-6" [form]="form"></app-text-input>
            <app-date-input id="dateOfAuthorization" class="fr-3" [form]="form"></app-date-input>
            <app-date-input id="authorizationFrom" class="fr-3" [form]="form"></app-date-input>
            <app-date-input id="authorizationTo" class="fr-3" [form]="form"></app-date-input>
            <div class="fr-3"></div>
        }

        @if (isDoctor) {
            <app-search-doctor-specialization [form]="form"
                class="fr-4"></app-search-doctor-specialization>
            <app-select-input
                [form]="form"
                [label]="workplacePrefix + 'label'"
                id="doctorWorkplaceId"
                class="fr-2"
                labelKey="name"
                valueKey="id"
                [staticOptions]="store2.workplaces()"
                appendTo="body"
            ></app-select-input>
        }

        @if (isDoctor && ((form.value.doctorWorkplaceId || 0) > 0)) {
            <app-button
                [label]="workplacePrefix + 'labelEdit'"
                (clickEvent)="openWorkplaceDialog(form.value.doctorWorkplaceId)"
                class="fr-2"
            ></app-button>
        }

        @if (isDoctor) {
            <app-button
                [label]="workplacePrefix + 'labelNew'"
                (clickEvent)="openWorkplaceDialog()"
                class="fr-2"
            ></app-button>
        }

        <app-text-input id="internNote" class="fr-12" [form]="form"></app-text-input>
    </div>
</div>

<app-warn-float-message [visible]="!!existingIdByEmail">
    {{ "database.persons.contacts.userAlreadyExists1" | translate }}
    <app-link-button [label]="existingNameByEmail" (clickEvent)="navigateToPersonDetail()"></app-link-button>
    {{ "database.persons.contacts.userAlreadyExists2" | translate }}
</app-warn-float-message>
<app-warn-float-message [visible]="existingUsersByName.length > 0">
    {{ "database.persons.contacts.nameAlreadyUsed1" | translate }}
    {{ existingUsersByName.length }}
    <app-pluralization class="px-1" [count]="existingUsersByName.length" [key]="'user'"></app-pluralization>
    {{ "database.persons.contacts.nameAlreadyUsed2" | translate }}
    <app-link-button label="database.persons.contacts.nameAlreadyUsed3"
        (clickEvent)="openExistingUserSelection()"
    ></app-link-button>
    {{ "database.persons.contacts.nameAlreadyUsed4" | translate }}
</app-warn-float-message>
